import { render } from "./ProjectsList.vue?vue&type=template&id=63a3ee58&scoped=true&ts=true"
import script from "./ProjectsList.vue?vue&type=script&lang=ts"
export * from "./ProjectsList.vue?vue&type=script&lang=ts"

import "./ProjectsList.vue?vue&type=style&index=0&id=63a3ee58&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a3ee58"]])

export default __exports__